import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { TokenService } from '../services/token.service';
import { AuthService } from '../services/auth.service';
import { environment } from '../../environments/environment';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const tokenService = inject(TokenService);
  const authService = inject(AuthService);

  if (!req.url.startsWith(environment.apiUrl)) {
    return next(req);
  }

  const urlPath = req.url.replace(environment.apiUrl, '').split('?')[0];

  // Rutas que NUNCA deben llevar token (ej: login, register)
  const noAuthEndpoints = ['/login', '/register', '/auth/google'];

  if (noAuthEndpoints.includes(urlPath)) {
    return next(req);
  }

  // ✅ Para todo lo demás: agregar token SI existe
  // Las rutas públicas del backend aceptan requests con o sin token
  const token = tokenService.token;

  const request = token
    ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } })
    : req;

  return next(request).pipe(
    catchError((error) => {
      // Si el backend rechaza el token (expirado/revocado), limpiar sesión
      if (error.status === 401 && token && !noAuthEndpoints.includes(urlPath)) {
        authService.clearAuth();
      }
      return throwError(() => error);
    }),
  );
};
